import { trackEvent } from 'dibs-tracking';

export const locations = {
    VISUALLY_SIMILAR: 'similar items',
    MY_FAVORITES: 'my favorites',
    RECOMMENDED_FOR_YOU: 'favorites|recommendations',
    DISCOVER_FEED: 'discover feed',
};

function trackFolderEvent(action, label, noteIncluded = false, itemPk = null) {
    let eventInfo = {
        label,
        action,
        category: 'item favoriting',
        value: noteIncluded ? 1 : 0,
    };

    if (itemPk) {
        eventInfo = { ...eventInfo, additional: { itemPk } };
    }

    if (label) {
        trackEvent(eventInfo);
    }
}

export function trackFolderClick(location) {
    trackFolderEvent('item favoriting folder clicked', location);
}

export function trackItemRemoved(location) {
    trackFolderEvent('item removed from folder', location);
}

export function trackItemAdded(location, noteIncluded = false, itemPk = null) {
    trackFolderEvent('item added into folder', location, noteIncluded, itemPk);
}

export function trackFolderCreated(location, noteIncluded = false) {
    trackFolderEvent('item favoriting folder created', location, noteIncluded);
}

export const folderTrackingHooks = {
    trackFolderClick,
    trackItemRemoved,
    trackItemAdded,
    trackFolderCreated,
};

export function getFolderTrackingHooks(location) {
    let hooks = folderTrackingHooks;

    if (location) {
        hooks = Object.keys(folderTrackingHooks).reduce(function(map, current) {
            map[current] = folderTrackingHooks[current].bind(null, location);
            return map;
        }, {});
    }

    return hooks;
}
